export enum UserRoles {
  Admin = "FaultAdmin",
  Reader = "FaultReader",
  Editor = "FaultEditor",
  Handler = "FaultHandler",
}

// Display names for roles
export const UserRoleDisplayNames: Record<UserRoles, string> = {
  [UserRoles.Admin]: "Fault Admin",
  [UserRoles.Reader]: "Fault Reader",
  [UserRoles.Editor]: "Fault Editor",
  [UserRoles.Handler]: "Fault Handler",
};

export enum FaultLogStatus {
  Open = "Open",
  Draft = "Draft",
  NotToBeRepaired = "Not to be repaired",
  Deleted = "Deleted",
  Closed = "Closed",
}

export const FaultLogStatusList: FaultLogStatus[] = [
  FaultLogStatus.Open,
  FaultLogStatus.Draft,
  FaultLogStatus.NotToBeRepaired,
  FaultLogStatus.Deleted,
  FaultLogStatus.Closed,
];

export enum FaultLogCustomerFlag {
  SenstiveA = "safety_sensitive_a",
  SensitiveB = "safety_sensitive_b",
  PSABackup = "psa_backup",
  Redline = "redline",
}

export const FaultLogCustomerFlagList: FaultLogCustomerFlag[] = [
  FaultLogCustomerFlag.SenstiveA,
  FaultLogCustomerFlag.SensitiveB,
  FaultLogCustomerFlag.PSABackup,
  FaultLogCustomerFlag.Redline,
];

export enum FaultLogPriority {
  Low = "Low",
  Medium = "Medium",
  High = "High",
}

export const FaultLogPriorityList: FaultLogPriority[] = [FaultLogPriority.Low, FaultLogPriority.Medium, FaultLogPriority.High];

export enum FaultLogTelemetrySystem {
  AnovaTranscend = "Anova Transcend",
  AWSIoT = "AWS IoT",
  IP21 = "IP21",
  LD = "LD",
  ERAM = "ERAM",
  Parax = "Parax",
  XMPro = "XMPro",
}

export const FaultLogTelemetrySystemList: FaultLogTelemetrySystem[] = [
  FaultLogTelemetrySystem.AnovaTranscend,
  FaultLogTelemetrySystem.AWSIoT,
  FaultLogTelemetrySystem.IP21,
];

export enum FaultLogLogisticsImpact {
  NoReadings = "No readings",
  IntermittentReadings = "Intermittent readings",
  ReadingsSuspended = "Readings suspended",
  WillFailSoon = "Will fail soon",
  DataQuality = "Data Quality",
  None = "None",
}

export const FaultLogLogisticsImpactList: FaultLogLogisticsImpact[] = [
  FaultLogLogisticsImpact.NoReadings,
  FaultLogLogisticsImpact.IntermittentReadings,
  FaultLogLogisticsImpact.ReadingsSuspended,
  FaultLogLogisticsImpact.WillFailSoon,
  FaultLogLogisticsImpact.DataQuality,
  FaultLogLogisticsImpact.None,
];

export enum FilterOperator {
  /// <summary>
  /// Equal comparison
  /// </summary>
  Equal,
  /// <summary>
  /// Not equal comparison
  /// </summary>
  NotEqual,
  /// <summary>
  /// Greater than comparison
  /// </summary>
  GreaterThan,
  /// <summary>
  /// Greater than or equal comparison
  /// </summary>
  GreaterThanOrEqual,
  /// <summary>
  /// Less than comparison
  /// </summary>
  LessThan,
  /// <summary>
  /// Less than or equal comparison
  /// </summary>
  LessThanOrEqual,
  /// <summary>
  /// String contains comparison
  /// </summary>
  Contains,
  /// <summary>
  /// String starts with comparison
  /// </summary>
  StartsWith,
  /// <summary>
  /// String ends with comparison
  /// </summary>
  EndsWith,
  /// <summary>
  /// Value is in a list of values
  /// </summary>
  In,
  /// <summary>
  /// Value is not in a list of values
  /// </summary>
  NotIn,
  /// <summary>
  /// Value is null
  /// </summary>
  IsNull,
  /// <summary>
  /// Value is not null
  /// </summary>
  IsNotNull,
}

export enum LogicalOperator {
  /// <summary>
  /// Logical AND
  /// </summary>
  And,
  /// <summary>
  /// Logical OR
  /// </summary>
  Or,
}

export enum DataType {
  Text = "Text",
  Int = "Int",
  Decimal = "Decimal",
  Date = "Date",
  DateTime = "DateTime",
  Boolean = "Boolean",
  DropDown = "DropDown",
}

export enum ToastInfoType {
  Info,
  Warning,
  Error,
  Success,
}

export enum FaultLogOwner {
  Engineering = "Engineering",
  Logistics = "Logistics",
  TelemetryCenterOrEuroTelemetry = "Telemetry Center/Euro Telemetry",
  SystemFollowUp = "System Follow Up",
}

export const FaultLogOwnerList: FaultLogOwner[] = [
  FaultLogOwner.Engineering,
  FaultLogOwner.Logistics,
  FaultLogOwner.TelemetryCenterOrEuroTelemetry,
  FaultLogOwner.SystemFollowUp,
];
